import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/nvwa")({
  component: NvwaSectionLayout,
});

function NvwaSectionLayout() {
  return <Outlet />;
}
